import { Table } from "antd";
import { useEffect, useState } from "react";

const ShowRecruiters = ({ record }) => {
  const users = record?.users || [];
  const count = users.length;
  const [usersData, setUserData] = useState([]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (value, row) => {
        return <span className="capitalize">{value}</span>;
      },
    },
    {
      title: "EMAIL",
      dataIndex: "email",
      key: "email",
      render: (value, row) => {
        return <span>{value}</span>;
      },
    },
    {
      title: "ROLE",
      dataIndex: "role",
      key: "role",
      render: (value, row) => {
        return <span className="capitalize">{value}</span>;
      },
    },
    {
      title: "TOTAL TIN USED",
      dataIndex: "totalTin",
      key: "totalTin",
      render: (value, row) => {
        return <span>{value}</span>;
      },
    },
  ];

  useEffect(() => {
    const _rows = [];
    for (let row of users) {
      console.log(row);
      _rows.push({
        name: row?.user_name,
        email: row?.user_email,
        role: row?.user_role,
        totalTin: row?.total_tin_used || 0,
      });
    }

    setUserData(_rows);
  }, [users]);

  return (
    <Table
      columns={columns}
      dataSource={usersData}
      pagination={{
        total: count,
        pageSizeOptions: ["5", "10", "30"],
        showSizeChanger: true,
        //   current: 1,
        //   onChange: () => {},
      }}
      showSorterTooltip={false}
      scroll={{ x: true }}
      style={{ whiteSpace: "pre" }}
      exportFileName="details"
      size="small"
    />
  );
};

export default ShowRecruiters;
